import { render, staticRenderFns } from "./ModalBranchEdit.vue?vue&type=template&id=79d1e5c0&scoped=true"
import script from "./ModalBranchEdit.vue?vue&type=script&lang=js"
export * from "./ModalBranchEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalBranchEdit.vue?vue&type=style&index=0&id=79d1e5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d1e5c0",
  null
  
)

export default component.exports